import { Button, SxProps } from '@mui/material';
import { ReactNode } from 'react';

interface SecondaryButtonProps {
  children: ReactNode;
  action?: () => void;
  referenceElement?: React.RefObject<HTMLButtonElement>;
  border?: string;
  minWidth?: string;
  startIcon?: ReactNode;
  sx?: SxProps;
}
const SecondaryButton = ({
  children,
  action,
  referenceElement,
  border,
  minWidth,
  startIcon,
  sx
}: SecondaryButtonProps) => {
  return (
    <Button
      onClick={action}
      color="secondary"
      variant="outlined"
      disableElevation
      ref={referenceElement}
      disableFocusRipple={true}
      startIcon={startIcon}
      sx={{ borderRadius: 2, borderColor: border ? border : 'inherit', minWidth: minWidth, ...sx }}
    >
      {children}
    </Button>
  );
};

export default SecondaryButton;
